import React, { FC } from 'react';
import { BreadcrumbNodeType } from './types';

type Props = {
  node?: BreadcrumbNodeType;
};

const BreadcrumbNode: FC<Props> = ({ node }) => {
  if (!node || (node && !node.name)) {
    return null;
  }

  return (
    <>
      <span>{'>'}</span>
      <span>{node.name}</span>
      <BreadcrumbNode node={node.next} />
    </>
  );
};

export default BreadcrumbNode;
